import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge } from "reactstrap"
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { ImageBaseUrl } from "helpers/file_upload_helper";
import { COLLHUB_SEARCH, DRIVERS_SEARCH } from "helpers/api_endpoints";
import QRCode from "react-qr-code";
import Select from "react-select";
import NoImage from "assets/images/no-image.png";
//meta title
document.title = "Collection Hubs";
const CollHubList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collHubId, setCollHubId] = useState('');
    const [driverId, setDriverId] = useState('');
    const [name, setName] = useState('');
    const [collHubs, setCollHubs] = useState([]);
    const [drivers, setDrivers] = useState([]);


    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({admin:1});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        post(`${COLLHUB_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
            .then(response => {
                const data = response.data;
                setCollHubs(data.data);
                setTotalPages(data.pagination.totalPages);
                setPage(data.pagination.currentPage);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)

            })
    }, [page, filters]);

    useEffect(() => {
        successMessage();
            post(`${DRIVERS_SEARCH}`)
            .then(response => {
                const data = response.data;
                setDrivers(data.map((driver, index) =>{
                    return {value:driver.id, label:driver.name}
                }));
            })
            .catch(error => {
                console.log(error)
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })
    }, []);

    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                location.state.successMessage = '';
                setsuccessMsg('');
            }, 4000)
        }
    };

    const handleFilter = (type, value) => {
        const filtvalues = {admin:1};
        if (value) {
            switch (type) {
                case 'driverId':
                    setDriverId(value);
                    filtvalues.driverId = value;
                    break;
                case 'name':
                    setName(value);
                    filtvalues.name = value;
                    break;
                default:
                    break;
            }
        }
        setFilters(filtvalues);
    }

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Collection Hub" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <CardTitle>
                                    <Link to="/collhub/add" >
                                        <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                    </Link>
                                </CardTitle>

                                <div style={{ margin: "25px" }}>
                                    <div className="row">
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                            name="name"
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e) => handleFilter('name',e.target.value)}
                                                        />
                                        </div>
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Driver Name</Trans></Label>
                                            <Select
                                                            name="driverId"
                                                            value={drivers.find(el => el.value==driverId)}
                                                            options={drivers} 
                                                            className="form-control select2"
                                                            onChange={(e) => handleFilter('driverId',e.value)}
                                                        />
                                        </div>
                                    </div>
                                </div>


                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>ID</Trans></th>
                                                    <th className="text-center"><Trans>Name</Trans></th>
                                                    <th><Trans>Driver Name</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={7} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    collHubs.map((collHub, index) => (
                                                        <tr key={index}>
                                                            <td>{collHub.id}</td>
                                                            <td>{collHub.name}</td>
                                                            <td>{collHub.driver?collHub.driver.name:''}</td> 
                                                            <td><Link to={`/collhub/edit/${collHub.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={`/collhub/remove/${collHub.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br></br>
                                    <div className="text-center">
                                        {/* Pagination controls */}
                                        <button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
                                            <Trans>Previous</Trans>
                                        </button>&nbsp;
                                        <button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
                                            <Trans>Next</Trans>
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )
}

export default CollHubList
